import { useState } from 'react'
import { isEmailValid } from '../../common/helpers'
import { useAuth } from '../../common/context'

interface Values {
  email: string
  password: string
}

export const initialValues: Values = {
  email: '',
  password: ''
}

export const validate = (values: Values) => {
  const errors: Partial<Values> = {}

  if (!values.email) {
    errors.email = 'Required'
  } else if (!isEmailValid(values.email)) {
    errors.email = 'Invalid email address'
  }
  if (!values.password) {
    errors.password = 'Required'
  }

  return errors
}

const useMFAuth = () => {
  const { tempUser, mfaLogin } = useAuth()

  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    generalError: "",
    codeError: "",
  });

  return { code, setCode, tempUser }
}

export default useMFAuth
